import { s as y } from "./index.es-XNBESE3P.js";
import { l as f, i as h } from "./logger-_fg_Za9y.js";
async function C(t, { hitDecorators: e, ...r }, o) {
  const n = await o(t, r);
  if (!n.products?.hits?.length || !e?.length)
    return n;
  const c = (s) => e.reduce((i, a) => a(i), s);
  return {
    ...n,
    products: {
      ...n.products,
      hits: n.products.hits.map(c)
    }
  };
}
function p(t, e, r) {
  const o = JSON.stringify(e);
  try {
    r.setItem(t, o);
  } catch (n) {
    f.warn(n);
  }
}
function g(t, e) {
  try {
    const r = e.getItem(t);
    if (r)
      return JSON.parse(r);
  } catch (r) {
    f.warn(r);
  }
}
function P(t, e) {
  p(t, e, localStorage);
}
function R(t, e) {
  p(t, e, sessionStorage);
}
function _(t) {
  return g(t, localStorage);
}
function b(t) {
  return g(t, sessionStorage);
}
const S = "nosto:search-js:cache", N = 60 * 1e3;
function T(t, e) {
  R(S, { query: t, result: e, created: Date.now() });
}
function z(t) {
  const e = b(S);
  if (!e || !I(e))
    return null;
  const r = d(e.query);
  return !h(d(t), r) || Date.now() - e.created > N ? null : e.result;
}
function d(t) {
  const e = {
    ...t,
    time: void 0,
    products: {
      ...t.products,
      size: void 0
    }
  };
  return JSON.parse(JSON.stringify(e));
}
function I(t) {
  return typeof t == "object" && t !== null && "query" in t && "result" in t && "created" in t;
}
async function O(t, { usePersistentCache: e, ...r }, o) {
  if (!e)
    return o(t, r);
  const n = await E(t, r, o);
  return T(t, n), n;
}
async function E(t, e, r) {
  const { from: o = 0, size: n = 0 } = t.products || {}, c = z(t);
  if (!c)
    return await r(t, e);
  const s = c?.products?.size ?? 0, i = c?.products?.hits ?? [];
  if (n === s)
    return c;
  if (n < s)
    return {
      ...c,
      products: {
        ...c.products,
        size: n,
        hits: i.slice(0, n),
        total: c.products?.total || 0
      }
    };
  const a = n - i.length, m = o > 0 ? o + 1 : n - a, w = {
    ...t,
    products: {
      ...t.products,
      from: m,
      size: a
    }
  }, l = await r(w, e);
  return {
    ...c,
    products: {
      ...c.products,
      size: n,
      hits: [...c.products?.hits || [], ...l.products?.hits || []],
      total: l.products?.total || 0
    }
  };
}
const J = 3e4, u = /* @__PURE__ */ new Map();
function k(t, e) {
  const r = u.get(t);
  if (!r) return;
  const o = Date.now() - r.created > J, n = h(e, r.query);
  if (o || !n) {
    u.delete(t);
    return;
  }
  return r.result;
}
function D(t, e, r) {
  u.set(t, {
    query: e,
    result: r,
    created: Date.now()
  });
}
async function L(t, e, r) {
  if (!e.useMemoryCache)
    return r(t, e);
  const o = JSON.stringify(t), n = k(o, t);
  if (n) return n;
  const c = await r(t, e);
  return D(o, t, c), c;
}
function M(t) {
  return new Promise((e) => setTimeout(e, t));
}
async function V(t, { maxRetries: e = 0, retryInterval: r = 0, ...o }, n) {
  let c = 0;
  for (; ; )
    try {
      return await n(t, o);
    } catch (s) {
      if (c >= e)
        throw s;
      if (!W(s))
        throw f.info("Skipping retry logic for", s), s;
      c++, await M(r);
    }
}
function W(t) {
  return !t || typeof t != "object" ? !1 : !("status" in t) || j(t.status);
}
function j(t) {
  return typeof t == "number" && (t < 400 || t >= 500);
}
async function F(t, e = {}) {
  const r = await new Promise(y);
  return x(r.search, V, L, O, C)(t, e);
}
function x(t, ...e) {
  return e.reduce((r, o) => (n, c) => o(n, c, r), t);
}
export {
  P as a,
  _ as g,
  F as s
};
